import { readFile, writeFile } from 'fs/promises';

/**
 * Convert MEMORY.md to CLAUDE.md
 *
 * CLAUDE.md supports @import syntax natively, so we can
 * directly copy the content without expanding imports.
 *
 * @param sourcePath - Path to MEMORY.md
 * @param targetPath - Path to output CLAUDE.md
 */
export async function memoryToClaude(sourcePath: string, targetPath: string): Promise<void> {
  try {
    // Read MEMORY.md content
    const content = await readFile(sourcePath, 'utf-8');

    // CLAUDE.md format is compatible with MEMORY.md
    // Just write the content directly
    await writeFile(targetPath, content, 'utf-8');
  } catch (error) {
    throw new Error(
      `Failed to convert MEMORY.md to CLAUDE.md: ${(error as Error).message}`
    );
  }
}
